import React, {useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Confirmcall from "./confirmcall";
import { Button } from 'reactstrap';
const Renderqueue = ({ list, lastBookElementRef,handleConfirmSubmitcall,reload }) => {
  const url =
    "https://wms.advanceagro.net/wsface/api/face/RealImage?IdentityID=";
 
    const [reloadf, setreload] = useState(false);
    const [callid, setcallid] = useState(false);
  const [askConfirm, setaskConfirm] = useState(false);
  const [Getdatashow, setGetdatashow] = useState([]);
  const [message, setmessage] = useState("ยืนยันเรียกคิว");
  const [isOpenff, setisOpenf] = useState([]);
//   const handleConfirmSubmitcall = () => {


//   };
  const handleCancleSubmit = () => {
    setaskConfirm(false);  
  };
  const handlereload = (even) => {
      setreload(even);
      reload(even);    
  };
  const handelClick = (even) => {
    //console.log("wwwws",even)
    
    setcallid(even)
    setaskConfirm(true);
 
  };
   //console.log("qqq",callid)
  useEffect(() => {
    //setaskConfirm(isOpenf)
    if (!askConfirm) return;
    const loadData = async () => {
      setGetdatashow();
      //(isOpenf)
    };
    loadData();
//console.log("opr",isOpenff)
  }, [askConfirm,isOpenff]);

  // const handleConfirmSubmitcall = (event) =>{
  //   console.log("event = ", event);
  // }
  //console.log("dad", isOpenf);
  return (
    <>
      <Confirmcall
        isOpen={askConfirm}
        onConfirm={handleConfirmSubmitcall}
        onCancel={handleCancleSubmit}
        message={message}
        listcall = {callid}
        reload={handlereload}
        
      />

      {list &&
        url &&
        list.map((item, index) => {
          if (list.length === index - 1) {
            return (
              <div className="container-fluid" key={item.no}>
                <div className="card border-secondary m-1 ">
                  {/* <div className="card-body"> */}
                  <div ref={lastBookElementRef} className="row m-1">
                     <div className="container col-xs-6 col-sm-4 col-md-2 lg-1 ">
                      <div style={{ fontSize: "22px" }}>
                        <span className="badge rounded-pill bg-primary">
                          {item.no}
                        </span>
                      </div>                   
                      <div style={{ fontSize: "14px" }}>
                        {item.comname}
                      </div>
                      {/* <div style={{ fontSize: "14px" }}>
                        {item.CustomerTypeName}
                      </div> */}
                    </div> 

                     <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">

                    <div className="mytooltip tooltip-effect-1">
                      <span className="tooltip-item">
                        <span className="d-none d-md-inline text-black pr-2">
                          <img
                            className="rounded-circle ms-2"
                            src={url + item.identityid + "&size=320"}
                            alt =""
                            style={{
                            
                              maxHeight: 50,
                              Width: 300,
                            }}
                          />{" "}
                          {item.drivenname}{" "}
                        </span>
                      </span>

                      <span className="tooltip-content clearfix">
                        <img
                          className="rounded-circle ms-2"
                          src={url + item.identityid + "&size=320"}
                          alt=""
                          style={{
                            width: "100%",
                            minHeight: "300px",
                            minWidth: "300px",
                          }}
                        />

                        <span className="tooltip-text"></span>
                      </span>
                    </div>

                  
                    </div> 

                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          บริษัทส่งสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.comname}
                          </small>{" "}
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          พนักงานขับรถ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.drivenname}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          บัตรประชาชน :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.identityid}
                          </small>
                        </h6>
                      </div>

                      <div></div>
                    </div>
                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          เบอร์โทร :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.tel}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.firstname}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วันที่ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.daterecord}
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div>
                        <h6>
                          {" "}
                          สถานะ :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-info text-dark">
                              {item.status}
                            </span>
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          กด :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.storename}
                          </small>
                        </h6>
                      </div>
                      {item.status =="เรียกรถแล้ว" ? 
                           <Button
                          type="button"
                          color="success"
                          disabled ={true}
                          value ={item.ID}
                          onClick={()=>handelClick([item.id,item.comname])}
                          className="btn btn-primary btn-sm m-2" 
                         
                          >
                        {item.status}
                        </Button> : item.status =="เรียกซ้ำ" ?  
                        <Button
                          type="button"
                          onClick={()=>handelClick([item.id,item.comname,"3"])}
                          value ={item.ID}
                          className="btn btn-primary btn-sm m-2" 
                          color="danger"
                          >
                            {item.status}
                        </Button>  :    <Button                       
                          type="button"
                          value ={item.ID}
                          onClick={()=>handelClick([item.id,item.comname,"3"])}
                          className="btn btn-primary btn-sm m-2" 
                          color="warning"
                          >
                            {item.status}
                        </Button>
                        }  
                      {/* <a style={{ width: 50 }}>
                        <button
                          type="button"
                          onClick={handelClick}
                          className="btn btn-primary btn-sm m-2"
                        >
                          Call
                        </button>
                      </i> */}


                      {/* <Link
                        style={{ width: "50px" }}
                        to={`/register/${item.AutoID}`}
                      >
                        <button
                          type="button"
                          className="btn btn-primary btn-sm m-2"
                        >
                          {item.receive_weightin > 0 ? "View" : "Call"}
                        </button>
                      </Link> */}
                    </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="container-fluid" key={item.no}>
                <div className="card border-secondary m-1 ">
                    
                  {/* <div className="card-body"> */}
                  <div className="row m-1">
                      <div className="container col-xs-6 col-sm-4 col-md-2 lg-1 ">
                    <div style={{ fontSize: "22px" }}>
                      <span className="badge rounded-pill bg-primary">
                        {item.no}
                      </span>
                    </div>
                    
                    <div style={{ fontSize: "14px" }}>
                      {item.comname}
                    </div>
                    {/* <div style={{ fontSize: "14px" }}>
                      {item.CustomerTypeName}
                    </div> */}
                  </div>  

                    <div className="container col-xs-6 col-sm-4 col-md-1 lg-1">
                      <div className="mytooltip tooltip-effect-1">
                        <span className="tooltip-item">
                          <span className="d-none d-md-inline text-black pr-2">
                            <img
                              className="rounded-circle ms-2"
                              src={url + item.identityid + "&size=320"}
                              alt=""
                              style={{
                                maxHeight: 50,
                                Width: 300,
                              }}
                            />{" "}                         
                          </span>
                        </span>

                        <span className="tooltip-content clearfix">
                          <img
                            className="rounded-circle ms-2"
                            src={url + item.identityid + "&size=320"}
                            alt=""
                            style={{
                              width: "100%",
                              minHeight: "300px",
                              minWidth: "300px",
                            }}
                          />

                          <span className="tooltip-text"></span>
                        </span>
                      </div>
                    </div>

                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      {/* <div style={{ fontSize: "14px" }}>
                        <h6>
                          บริษัทส่งสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.comname}
                          </small>{" "}
                        </h6>
                      </div> */}
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          พนักงานขับรถ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.drivenname}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          บัตรประชาชน :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.identityid}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.producttype}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ชื่อสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.productname}
                          </small>
                        </h6>
                      </div>
                    </div>
                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          เบอร์โทร :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.tel}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.firstname}
                          </small>
                        </h6>
                      </div>
                    
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วันที่ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.daterecord}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          เลขที่ใบชั่ง:
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.weightno}
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div>
                        <h6>
                          {" "}
                          สถานะ :
                          <small style={{ fontSize: "18px" }}>
                            {" "}

                            

                         
                           {item.status =="เรียกรถแล้ว" ? 
                           <Button
                          type="button"
                          color="success"
                          disabled ={true}
                          value ={item.ID}
                          onClick={()=>handelClick([item.id,item.comname])}
                          className="btn btn-primary btn-sm m-2" 
                         
                          >
                            {item.status}
                        </Button> : item.status =="เรียกซ้ำ" ?  
                        <Button
                          type="button"
                          onClick={()=>handelClick([item.id,item.comname,"3"])}
                          value ={item.ID}
                          className="btn btn-primary btn-sm m-2" 
                          color="danger"
                          >
                            {item.status}
                        </Button>  :    
                        <Button                       
                          type="button"
                          value ={item.ID}
                          onClick={()=>handelClick([item.id,item.comname,"3"])}
                          className="btn btn-primary btn-sm m-2" 
                          color="warning"
                          >
                            {item.status}
                        </Button>
                        }     
                        
                                                            
                          </small>
                        </h6>
                      </div>
                    </div>
                    <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">

                    {item.status =="เรียกรถแล้ว" &&  item.weightno =="" &&
                     <Button                       
                          type="button"
                          value ={item.ID}
                          onClick={()=>handelClick([item.id,item.comname,"1"])}
                          className="btn btn-primary btn-sm m-2" 
                          color="warning"
                          >
                            ยกเลิก
                            {/* {item.status} */}
                        </Button>
                        }

                      </div>
                    {/* <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          กด :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.storename}
                          </small>
                        </h6>
                      </div>

                      <a style={{ width: 50 }}>
                        <button
                          type="button"
                          onClick={handelClick}
                          className="btn btn-primary btn-sm m-2"
                          
                        >
                          Call
                        </button>
                      </i>

                
                    </div>
                    */}
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default Renderqueue;
